import { Home, Wrench, Zap, Wind, HardHat, PenTool, ClipboardList, Settings, Heart, HelpCircle, type LucideIcon } from "lucide-react";

export interface NavItem {
  path: string;
  label: string;
  /** Shorter label used in the mobile tab bar */
  shortLabel?: string;
  icon: LucideIcon;
  desc: string;
}

/** Trade hubs — this list is fixed. New tools become tabs inside one of these pages. */
export const primaryNav: NavItem[] = [
  { path: "/", label: "Home", icon: Home, desc: "Search, favorites & recent tools" },
  { path: "/pipe", label: "Pipe", icon: Wrench, desc: "Sizing, fittings, plumbing & offsets" },
  { path: "/electrical", label: "Electrical", shortLabel: "Electric", icon: Zap, desc: "Wire, conduit, motors & equipment" },
  { path: "/ductwork", label: "Ductwork", shortLabel: "Duct", icon: Wind, desc: "Duct sizing, airflow & HVAC/R" },
  { path: "/structural", label: "Structural", shortLabel: "Struct", icon: HardHat, desc: "Beams, anchors, seismic & loads" },
];

/** Everything that isn't a trade hub lives behind the "More" menu. */
export const secondaryNav: NavItem[] = [
  { path: "/sketch", label: "Pipe Sketch", icon: PenTool, desc: "Isometric sketch pad & cut list" },
  { path: "/joblog", label: "Job Log", icon: ClipboardList, desc: "Track hours & job notes" },
  { path: "/help", label: "Help & FAQ", icon: HelpCircle, desc: "Guides, shortcuts & answers" },
  { path: "/settings", label: "Settings", icon: Settings, desc: "Defaults, theme & preferences" },
  { path: "/support", label: "Value 4 Value", icon: Heart, desc: "Support Trades Toolbelt" },
];
